import { gql } from "graphql-tag";

import { GraphQLRequest } from "@/services";

export interface AllProjectsResponse
{
    id: number;

    name: string;
    projectId: string;
}
export default class AllProjects extends GraphQLRequest<{ allProjects: AllProjectsResponse[] }>
{
    public static readonly Query = gql`query {
        allProjects {
            id,

            name,
            projectId
        }
    }`;

    public jsonWebToken?: string;

    public constructor(jsonWebToken?: string)
    {
        super();

        this.jsonWebToken = jsonWebToken;
    }

    public async execute(): Promise<AllProjectsResponse[]>
    {
        const response = await this._query(AllProjects.Query, { jsonWebToken: this.jsonWebToken });

        return response.allProjects;
    }
}
